import { SnackbarProvider } from "notistack";
import { PropsWithChildren } from "react";

export default function DialogProvider({ children }: PropsWithChildren) {
    return <>
        <SnackbarProvider anchorOrigin={{ horizontal: "right", vertical: "top" }} />
        {children}
    </>
}